<app-page-body
  *ngIf="
    !isVisibleForm &&
    !isNotActiveUserOrganization &&
    !isNotUserOrganization &&
    !isExpired &&
    !isExpireOrganization &&
    !pageConfig.isVisibleForm &&
    !isVisibleUploadForm &&
    !isNotAuthenticated &&
    !notAuthenticatedUser
  "
>
  <app-page-header
    [title]="pageVocabs + 'title'"
    [loading]="pageConfig.loading"
    [showDefaultBtns]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content tw-px-5 tw-mt-5">
    <!-----------------------------------------------  User Info -->
    <section>
      <fieldset class="tw-pb-[25px]">
        <legend>
          {{ pageVocabs + "title" | translate }}
        </legend>

        <!-- info -->
        <div class="row">
          <!-- fullName -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-3">
            <list-group-item
              [label]="'common.fullName' | translate"
              [value]="fullName | checkValue"
            >
            </list-group-item>
          </div>

          <!-- fatherName -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-3">
            <list-group-item
              [label]="'common.fatherName' | translate"
              [value]="model?.fatherName | checkValue"
            >
            </list-group-item>
          </div>

          <!-- birthDate -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-3">
            <list-group-item
              [label]="'common.birthDate' | translate"
              [value]="
                model?.birthDate
                  | dateConverter : translationService.currentLang()
                  | checkValue
              "
            >
            </list-group-item>
          </div>

          <!-- foreigner -->
          <div
            class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-3"
            *ngIf="model?.isForeigner"
          >
            <list-group-item
              [label]="pageVocabs + 'foreigner' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i class="fas fa-check text-success"></i>
              </div>
            </list-group-item>
          </div>

          <!-- nationalCode -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-3">
            <list-group-item
              [label]="
                model?.isForeigner
                  ? (pageVocabs + 'foreignerCode' | translate)
                  : ('common.nationalCode' | translate)
              "
              [value]="model?.nationalCode | checkValue"
            >
            </list-group-item>
          </div>

          <!-- identityNumber -->
          <div
            class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1"
            *ngIf="!model?.isForeigner"
          >
            <list-group-item
              [label]="'common.identityNumber' | translate"
              [value]="model?.identityNumber | checkValue"
            >
            </list-group-item>
          </div>

          <!-- userName -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.userName' | translate"
              [value]="model?.userName | checkValue"
            >
            </list-group-item>
          </div>

          <!-- email -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.email' | translate"
              [value]="model?.email | checkValue"
            >
            </list-group-item>
          </div>

          <!-- credit -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.myCredit' | translate"
              [hasCurrency]="true"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
                [credit]="model?.credit"
              >
                <div class="credit-number">
                  <span class="credit-number-text">
                    {{ model?.credit | numberSeparator }}
                  </span>
                </div>
              </div>
            </list-group-item>
          </div>

          <!-- phone -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.phone' | translate"
              [value]="model?.phone | checkValue"
            >
            </list-group-item>
          </div>

          <!-- organizationName -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.organizationName' | translate"
              [value]="model?.organizationName | checkValue"
            >
            </list-group-item>
          </div>

          <!-- expireDate -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.expireDate' | translate"
              [value]="
                model?.expireDate
                  | dateConverter : translationService.currentLang()
                  | checkValue
              "
            >
            </list-group-item>
          </div>

          <!-- isActiveSend -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.isActiveSend' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i
                  [ngClass]="
                    model?.isActiveSend
                      ? 'fas fa-check text-success '
                      : ' fas fa-times text-danger '
                  "
                >
                </i>
              </div>
            </list-group-item>
          </div>

          <!-- isAuthenticated -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.isAuthenticated' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i
                  [ngClass]="
                    model?.isAuthenticated
                      ? 'fas fa-check text-success '
                      : ' fas fa-times text-danger '
                  "
                >
                </i>
              </div>
            </list-group-item>
          </div>

          <!-- isAuthenticatedMobile -->
          <!-- <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.isAuthenticatedMobile' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i
                  [ngClass]="
                    model?.isAuthenticatedMobile
                      ? 'fas fa-check text-success '
                      : ' fas fa-times text-danger '
                  "
                >
                </i>
              </div>
            </list-group-item>
          </div> -->

          <!-- isDefault -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.isDefault' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i
                  [ngClass]="
                    model?.isDefault
                      ? 'fas fa-check text-success '
                      : ' fas fa-times text-danger '
                  "
                >
                </i>
              </div>
            </list-group-item>
          </div>

          <!-- isForeigner -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.isForeigner' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <i
                  [ngClass]="
                    model?.isForeigner
                      ? 'fas fa-check text-success '
                      : ' fas fa-times text-danger'
                  "
                >
                </i>
              </div>
            </list-group-item>
          </div>

          <!-- zipCode -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.zipCode' | translate"
              [value]="model?.zipCode | checkValue"
            >
            </list-group-item>
          </div>

          <!-- zoneName -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.city' | translate"
              [value]="model?.zoneName | checkValue"
            >
            </list-group-item>
          </div>

          <!-- <div class="xl:tw-w-2/3"></div> -->

          <!-- address -->
          <div class="xl:tw-w-1/2 tw-mt-1">
            <list-group-item
              [label]="'common.address' | translate"
              [value]="model?.address | checkValue"
            >
            </list-group-item>
          </div>

          <!-- description -->
          <div class="xl:tw-w-1/2 tw-mt-1">
            <list-group-item
              [label]="'common.description' | translate"
              [value]="model?.descriptions | checkValue"
            >
            </list-group-item>
          </div>

          <!-- mobile -->
          <div class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-mt-1">
            <list-group-item
              [label]="'common.mobile' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <div class="tw-p-2" *ngFor="let item of model?.mobile">
                  {{ item?.mobile | checkValue }}
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item?.isAuthenticated"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item?.isAuthenticated"
                  ></i>
                </div>
              </div>
            </list-group-item>
          </div>
        </div>
      </fieldset>
    </section>

    <section class="tw-mb-5 tw-w-full tw-flex tw-justify-end tw-items-center">
      <!--edit user btn-->
      <div class="tw-flex tw-justify-start tw-items-center tw-mt-3 tw-px-1">
        <button
          mat-ripple
          class="btn tw-w-[125px] tw-mt-1 button-shadow"
          [themeColor]="'btn'"
          (click)="getCurrentUserInfoApi(true)"
        >
          <span>{{ "common.edit" | translate }}</span>
          <i class="mdi mdi-account-edit mdi-18px tw-text-white"></i>
        </button>
      </div>

      <!-- upload documents btn-->
      <div class="tw-flex tw-justify-start tw-items-center tw-mt-3 tw-px-1">
        <button
          mat-ripple
          class="btn tw-w-[125px] tw-mt-1 button-shadow tw-ml-1"
          [themeColor]="'btn-info'"
          (click)="uploadDocuments()"
        >
          <span>{{ "common.uploadDocuments" | translate }}</span>
          <span class="mdi mdi-file-document tw-mx-1 tw-text-white"></span>
        </button>
      </div>
    </section>
  </div>
</app-page-body>

<ng-container *ngIf="isVisibleUploadForm || notAuthenticatedUser">
  <app-user-authentication-form (closeFormPage)="getFormResponse($event)">
  </app-user-authentication-form>
</ng-container>

<ng-container *ngIf="isNotAuthenticated">
  <app-organizations-authentication-form
    (closeFormPage)="getFormResponse($event)"
  >
  </app-organizations-authentication-form>
</ng-container>

<ng-container *ngIf="isNotActiveUserOrganization">
  <!-- first Alert -->
  <div class="row">
    <div
      class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 offset-md-4"
      style="margin-top: 200px"
    >
      <div class="tw-flex-center flex-column text-alert-danger">
        <i
          class="mdi mdi-alert-circle-outline mdi-65px text-alert-danger tw-mx-2 tw-mb-3 tw-text-[50px]"
        ></i>
        <span class="tw-text-xl tw-font-extrabold">{{
          "messages.notActiveOrganization" | translate
        }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isNotUserOrganization">
  <div class="row">
    <div
      class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 offset-md-4"
      style="margin-top: 200px"
    >
      <div class="tw-flex-center flex-column text-alert-danger">
        <i
          class="mdi mdi-alert-circle-outline mdi-65px text-alert-danger tw-mx-2 tw-mb-3 tw-text-[50px]"
        ></i>
        <span class="tw-text-xl tw-font-extrabold">{{
          "messages.notOrganization" | translate
        }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isExpireOrganization">
  <div class="row">
    <div
      class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 offset-md-4"
      style="margin-top: 200px"
    >
      <div class="tw-flex-center flex-column text-alert-danger">
        <i
          class="mdi mdi-alert-circle-outline mdi-65px text-alert-danger tw-mx-2 tw-mb-3 tw-text-[50px]"
        ></i>
        <span class="tw-text-xl tw-font-extrabold">{{
          "messages.expireOrganization" | translate
        }}</span>
      </div>

      <ng-container>
        <div (click)="onBuyPackage()" class="tw-flex-center tw-mt-[30px]">
          <a
            class="btn tw-text-[16px] tw-font-medium tw-h-[45px] tw-flex-center border border-blue btn-light-blue tw-w-[150px] btn-hover-rise"
            style="border-color: unset !important"
          >
            <ng-container class="tw-px-1">
              <i class="mdi mdi-22px mdi-shopping"></i>
              <span> {{ "common.buyPlan" | translate }}</span>
            </ng-container>
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isExpired">
  <div class="row">
    <div
      class="md:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 offset-md-4"
      style="margin-top: 200px"
    >
      <div class="tw-flex-center flex-column text-alert-danger">
        <i
          class="mdi mdi-alert-circle-outline mdi-65px text-alert-danger tw-mx-2 tw-mb-3 tw-text-[50px]"
        ></i>
        <span class="tw-text-xl tw-font-extrabold">{{
          "messages.expired" | translate
        }}</span>
      </div>
    </div>
  </div>
</ng-container>

<!--update organizational form-->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-user-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
    [isCurrentUser]="true"
  >
  </app-user-form>
</ng-container>
